export const lightnatural = {
  name: 'Light & Natural',
  color: [0.6313725490196078, 0.7450980392156863, 0.5843137254901961, 1],
  bg: [0.2, 0.4196078431372549, 0.5294117647058824, 1],
  grid1: [0.9803921568627451, 0.9372549019607843, 0.8313725490196079, 1],
  grid2: [0.6470588235294118, 0.48627450980392156, 0.396078431372549, 1],
}
